import { render, staticRenderFns } from "./new_chat_message.vue?vue&type=template&id=0aff2b6d&scoped=true&"
import script from "./new_chat_message.vue?vue&type=script&lang=js&"
export * from "./new_chat_message.vue?vue&type=script&lang=js&"
import style0 from "./new_chat_message.vue?vue&type=style&index=0&id=0aff2b6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff2b6d",
  null
  
)

export default component.exports